
import { graphql, type ResultOf, type VariablesOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const CreateListingMutation = graphql(`
  mutation CreateListing($input: CreateListingInput!) {
    createListing(input: $input) {
      __typename
      ... on Listing {
        id
        formattedAddress
        timezone
        bookingHorizonDays
        bookingUntil
      }
      ... on ListingLimitReachedError {
        message
      }
    }
  }
`);

export type CreateListingVariables = VariablesOf<typeof CreateListingMutation>;
export type CreateListingResult = ResultOf<typeof CreateListingMutation>;

export type CreatedListing = Extract<
  NonNullable<CreateListingResult['createListing']>,
  { __typename: 'Listing' }
>;

export async function runCreateListing(
  input: CreateListingVariables['input'],
): Promise<CreatedListing> {
  const data = await gqlRequest(CreateListingMutation, { input });
  const result = data.createListing;
  if (!result) {
    throw new Error('The listing could not be created. Please try again.');
  }
  // Domain errors (cap reached) carry a display-ready message.
  if (result.__typename !== 'Listing') throw new Error(result.message ?? 'Something went wrong. Please try again.');
  return result;
}
